import "./page-high-resolution-images-2026.scss";
import "../../js/core";
import { SwiperInit } from "../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs";
import Collapse from "bootstrap/js/src/collapse";

SwiperInit("swiper-1");

$(document).ready(function () {
  const $track = $(".slider-inner");

  if (!$track.length) return;

  $track.append($track.html());

  let position = 0;
  const speed = 40;

  let lastTime = null;

  function animate(time) {
    if (!lastTime) lastTime = time;

    const delta = (time - lastTime) / 1000;
    lastTime = time;

    const fullWidth = $track[0].scrollWidth;
    const half = fullWidth / 2;

    position -= speed * delta;

    if (Math.abs(position) >= half) {
      position = 0;
    }

    $track.css(
      "transform",
      "translate3d(" + position + "px, 0, 0)"
    );

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
});